import type { CustomerReservationDetailsStore } from '@iheartjane/data-access';
import type { ReservationMode } from '@iheartjane/types';
import compact from 'lodash-es/compact';

import type { ScheduleType, StoreSchedule } from '@jane/shared-ecomm/util';
// eslint-disable-next-line no-restricted-imports
import type {
  CartStore,
  NoStore,
  Store,
  StoreHeaderStore,
} from '@jane/shared/models';
import { isStore } from '@jane/shared/util';

const defaultInStorePickupText = 'In-store pickup';
const defaultCurbsidePickupText = 'Curbside pickup';

export const filterOrderingSchedules = (
  schedules: Array<StoreSchedule | null>,
  store: Store | NoStore | StoreHeaderStore
): StoreSchedule[] => {
  const curbsideMandatory = isStore(store)
    ? store.curbside_pickup_setting === 'mandatory'
    : false;
  const curbsideDisabled = isStore(store)
    ? store.curbside_pickup_setting === 'not_allowed'
    : false;

  const shouldExcludeSchedule = (schedule: StoreSchedule | null) => {
    return (
      (schedule?.type === 'pickup' && curbsideMandatory) ||
      (schedule?.type === 'curbside' && curbsideDisabled)
    );
  };

  return compact(
    schedules.filter((schedule) => !shouldExcludeSchedule(schedule))
  );
};

export const fulfillmentLabel = (
  store: Store | StoreHeaderStore | CustomerReservationDetailsStore,
  fulfillmentMode: ScheduleType | 'kiosk'
) => {
  const modeLabel = reservationModeLabel(store, fulfillmentMode);
  if (
    'curbside_pickup_setting' in store &&
    store.curbside_pickup_setting === 'allowed' &&
    modeLabel === 'pickup'
  )
    return defaultInStorePickupText;
  else if (modeLabel === 'curbside') return defaultCurbsidePickupText;
  return modeLabel;
};

export const reservationModeLabel = (
  store:
    | Store
    | NoStore
    | CustomerReservationDetailsStore
    | StoreHeaderStore
    | CartStore
    | null
    | undefined,
  reservationMode: ReservationMode | ScheduleType
) => {
  if (reservationMode === 'retail' || !isStore(store)) return reservationMode;

  const { reservation_mode_labels } = store;

  return (
    (reservation_mode_labels &&
      reservation_mode_labels[
        reservationMode as keyof typeof reservation_mode_labels
      ]) ||
    reservationMode
  );
};
